module.exports = __webpack_public_path__ + "img/b4cdfb1.png";